export enum INVENTORY_FILTER {
    type = 'type',
}
